var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCarritoEntrega(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "current",
    id: "__x0023_Layer_x0020_1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 26.817,
    height: 16.539,
    viewBox: "0 0 26.817 16.539",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_2843108759184"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_491",
    "data-name": "Grupo 491"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_161",
    "data-name": "Trazado 161",
    d: "M25.312,7.114h-.521L22.751,3.768a1.488,1.488,0,0,0-1.274-.726h-3.2V1.558A1.534,1.534,0,0,0,16.773,0H5.156A1.534,1.534,0,0,0,3.651,1.558V3.042H.538a.558.558,0,0,0,0,1.115H7.5a.558.558,0,0,0,0-1.115H4.726V1.558a.437.437,0,0,1,.429-.444H16.773a.437.437,0,0,1,.429.444V13.111H10.766a2.76,2.76,0,0,0-5.448,0H5.156a.436.436,0,0,1-.429-.441V9.577H7.5a.558.558,0,0,0,0-1.115H.538a.558.558,0,0,0,0,1.115H3.651V12.67a1.532,1.532,0,0,0,1.505,1.556h.162a2.76,2.76,0,0,0,5.448,0h8.52a2.76,2.76,0,0,0,5.448,0h.579a1.532,1.532,0,0,0,1.505-1.556v-4a1.532,1.532,0,0,0-1.505-1.556ZM8.042,15.341h0A1.672,1.672,0,1,1,9.658,13.67,1.647,1.647,0,0,1,8.042,15.341ZM18.278,4.156h3.2a.424.424,0,0,1,.363.207l1.68,2.75H18.278ZM22.01,15.341h0a1.672,1.672,0,1,1,1.616-1.671A1.646,1.646,0,0,1,22.01,15.341Zm3.732-2.671h0a.437.437,0,0,1-.429.441h-.579a2.76,2.76,0,0,0-5.448,0H18.278V8.227h7.034a.438.438,0,0,1,.429.444Z",
    transform: "translate(0 0)",
    fill: "current"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_162",
    "data-name": "Trazado 162",
    d: "M7.835,3.721a.533.533,0,0,0,.5-.556.533.533,0,0,0-.5-.558H1.3a.533.533,0,0,0-.5.558.533.533,0,0,0,.5.556Z",
    transform: "translate(0.798 3.146)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarritoEntrega);
export default __webpack_public_path__ + "static/media/carrito_entrega.84ff068524237eeeb6bdd2ffd71906f7.svg";
export { ForwardRef as ReactComponent };